"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOpponentIds = void 0;
var chat_1 = require("@yeobill/chat");
exports.getOpponentIds = function (dialog) {
    return chat_1.Dialogs.getOpponentIds(dialog);
};
//# sourceMappingURL=getOpponentIds.js.map